// A courier cannot serve a pure Click & Collect merchant (C&C on, delivery off), so the
// user-management pickers hide those from courier roles. Merchants already selected stay
// visible: hiding them would leave an invisible selection in the payload that the backend
// rejects with a cause the admin can neither see nor fix.
export interface MerchantOption {
  name: string;
  click_and_collect?: number;
  delivery_enabled?: number;
}

export const courierSelectableMerchant = (
  merchant: MerchantOption,
  role: string,
  selected: string[]
): boolean => {
  if (role !== 'Partner Courier') {
    return true;
  }
  return !(merchant.click_and_collect && !merchant.delivery_enabled) || selected.includes(merchant.name);
};
